import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireRole, useAuth } from "@/lib/auth";
import { LocationProvider } from "@/lib/location";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import DealDetail from "@/pages/DealDetail";
import { LoginPage, RegisterPage, AdminLoginPage } from "@/pages/Auth";
import SellerRegister from "@/pages/SellerRegister";
import StaticPage from "@/pages/StaticPage";
import CustomerPortal from "@/pages/customer/CustomerPortal";
import SellerApp from "@/pages/seller/SellerApp";
import AdminApp from "@/pages/admin/AdminApp";

const SellerRegisterGate = () => {
  const { user } = useAuth();
  return user?.role === "merchant" ? <Navigate to="/seller" replace /> : <SellerRegister />;
};

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/deals" element={<Browse />} />
            <Route path="/category/:slug" element={<Browse />} />
            <Route path="/deals/:slug" element={<DealDetail />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/seller/register" element={<SellerRegisterGate />} />
            <Route path="/privacy" element={<StaticPage page="privacy" />} />
            <Route path="/terms" element={<StaticPage page="terms" />} />
            <Route path="/contact" element={<StaticPage page="contact" />} />
            <Route path="/customer/*" element={<RequireRole roles={["customer"]}><CustomerPortal /></RequireRole>} />
            <Route path="/seller/*" element={<RequireRole roles={["merchant"]}><SellerApp /></RequireRole>} />
            <Route path="/admin/*" element={<RequireRole roles={["admin"]} loginPath="/admin/login"><AdminApp /></RequireRole>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
